import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import Layout  from '../components/Layout/Layout';
import protectedPageHOC from '../components/AuthRoute/protectedPageHOC';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AppItem  from '../components/AppItem/AppItem';
import IconButton from '@mui/material/IconButton';
import AddNewAppModal from '../components/Modal/AddNewAppModal/AddNewAppModal';
import AppsDataService from '../config/app.services';
import { LoaderToggleContext } from '../App';
import '../App.css';
import { AuthContext } from '../Context/auth';

export type AppDocDataType = {
  id: string;
  AppName: string;
  AppType: 'SQUARE';
  ApplicationID: string;
  ChatCode: string;
  LocationId: string;
  UserID: string;
  UserToken: string;
}

export type CreateAppDataType = Omit<AppDocDataType, 'id' | 'AppType' | 'ChatCode'>;

type AppsPageProps = {

}

const AppsPage: FunctionComponent<AppsPageProps> = (props) => {
  const [modalOpened, setModalOpened] = useState(false);
  const [apps, setApps] = useState<AppDocDataType[]>([]);
  const { loadingOn, loadingOff } = useContext(LoaderToggleContext);

  const { auth } = useContext(AuthContext);

  const getApps = async () => {
    try {
      const data = await AppsDataService.getAllApps(auth?.uid);
      setApps(data.docs.map((doc) => ({
        ...(doc as any).data(),
        id: doc.id
      })));
    } catch (e) {
      console.log('Apps list getting error: ', e);
    }
  };

  const deleteHandler = async (id: string) => {
    loadingOn();
    await AppsDataService.deleteApp(id, auth?.uid);

    await getApps();
    loadingOff();
  };

  const handleCreate = async (createData: CreateAppDataType) => {
    loadingOn();
    const newApp = {
      ...createData,
      AppType: 'SQUARE',
      // TODO: Replace with code generation
      ChatCode: '<script src="https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1"></script> <df-messenger intent="WELCOME" chat-title="BookingAgent" agent-id="013dd291-14c4-4e51-9836-5cb4933257d1" language-code="en" ></df-messenger>'
    }

    await AppsDataService.addApp(newApp, createData.UserID);

    loadingOff();
    await getApps();
    setModalOpened(false);
  }

  useEffect(() => {
    (async () => {
      loadingOn();

      await getApps();

      loadingOff();
    })();
  }, []);

  return (
    <Layout header={'Applications'} selectedRoute={'/apps'} >
      { modalOpened && (
        <AddNewAppModal
          opened={modalOpened}
          handleClose={() => setModalOpened(false)}
          handleCreate={handleCreate}
        />
      ) }
      { apps.map((doc) => (
        <AppItem
          data={doc}
          key={doc.id}
          onDelete={deleteHandler}
        />
      )) }
      <IconButton
        size={'large'}
        edge="start"
        color="inherit"
        aria-label="Exit"
        onClick={() => setModalOpened(true)}
        sx={{
          fontSize: '50px'
        }}
      >
        <AddCircleIcon fontSize={'inherit'} />
      </IconButton>
    </Layout>
  );
}

export default protectedPageHOC(AppsPage);
